<template>
    <ClientOnly>
        <Teleport to="body">
            <div class="fixed top-6 right-6 z-[9999] flex flex-col items-end gap-3 pointer-events-none">
                <TransitionGroup name="toast-slide">
                    <div
                        v-for="toast in toastStore.toasts"
                        :key="toast.id"
                        class="pointer-events-auto"
                    >
                        <CToast
                            :type="toast.type"
                            :title="toast.title"
                            :message="toast.message"
                            :duration="0"
                            :is-visible="true"
                            @close="toastStore.removeToast(toast.id)"
                        />
                    </div>
                </TransitionGroup>
            </div>
        </Teleport>
    </ClientOnly>
</template>

<script setup lang="ts">
import { useToastStore } from '@/stores/toast'
import CToast from './CToast.vue'

const toastStore = useToastStore()
</script>

<style scoped>
/* Toast slide animation */
.toast-slide-enter-active {
    animation: toast-slide-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.toast-slide-leave-active {
    animation: toast-slide-out 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-slide-move {
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes toast-slide-in {
    0% {
        opacity: 0;
        transform: translateX(100%) scale(0.9);
    }
    100% {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

@keyframes toast-slide-out {
    0% {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translateX(100%) scale(0.9);
    }
}
</style>

